module.exports = __webpack_public_path__ + "img/enamad.d59672d8.png";